import uniqueId from '@form-create/utils/lib/unique';
import { makeOptionsRule, makeRequiredRule } from '../../utils';
var label = '客户管理说明';
var name = 'holidaySetting';
export default {
  icon: 'iconfont iconxuanzeqi',
  label: label,
  name: name,
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      title: label,
      info: '',
      effect: {
        fetch: ''
      },
      checkType: 0
    };
  },
  props: function props() {
    // makeOptionsRule 需要接受分组和选项
    return [makeOptionsRule('options', {
      group: true
    }), makeRequiredRule()];
  },
  basic: function basic() {}
};